import { useNavigate } from "react-router-dom";
import { RoutesReact } from "../constants/routes";

export const useCustomNavigate = () => {
  const reactRouterDomNavigate = useNavigate();

  const getRoute = (
    route: keyof typeof RoutesReact,
    id?: Record<string, string> | string
  ): string => {
    if (!id) return RoutesReact[route];
    if (typeof id === "string") return RoutesReact[route].replace(":id", id);
    return Object.entries(id).reduce((acc, [key, value]) => {
      return acc.replace(`:${key}`, value);
    }, RoutesReact[route] as string);
  };

  const getQueryString = (query: Record<string, string | number>) =>
    Object.entries(query)
      .map((item) => item.join("="))
      .join("&");

  const navigate = (
    route: keyof typeof RoutesReact,
    id?: Record<string, string> | string,
    query?: Record<string, string | number>
  ) => {
    reactRouterDomNavigate(
      `${getRoute(route, id)}${query ? `?${getQueryString(query)}` : ""}`
    );
  };

  return { navigate, getRoute };
};
